import { Negotiation } from '@/modules/negotiation/entities/interfaces/negotiation';
import { get } from 'lodash';

const { REACT_APP_PROVIDER_BY_ID = '{}' } = process.env;

const providerById = JSON.parse(REACT_APP_PROVIDER_BY_ID);

const isProvider = <T = Negotiation>(negotiation: T, providerName: string) => {
  const providerId = get(negotiation, 'product.providerId');

  if (!providerId) {
    return false;
  }

  return providerById[providerId] === providerName;
};

export const isBradesco = <T = Negotiation>(negotiation: T) =>
  isProvider<T>(negotiation, 'bradesco');
export const isOmni = <T = Negotiation>(negotiation: T) => isProvider(negotiation, 'omni');
